@let testIdPrefix = 'countdown-modal';

<app-form-dialog-wrapper
    title="{{ data.title }}"
    [actions]="formDialogActions()"
    [testId]="testIdPrefix"
>
    <div>
        <p [attr.data-testid]="'message' | testid: testIdPrefix">{{ message() }}</p>
    </div>
    <div class="rcp-flex rcp-justify-center rcp-gap-5 rcp-text-center">
        <div class="rcp-countdown-box rcp-text-neutral-content p-2 rcp-flex rcp-flex-col">
            <span class="rcp-countdown rcp-font-poppins rcp-text-5xl">
                <span
                    style="--value: 24"
                    aria-live="polite"
                    aria-label="24"
                    >{{ countDownValue() | countDown: 'mm' }}
                </span>
            </span>
            {{ 'min' }}
        </div>
        <div class="rcp-pt-[36px] rcp-font-poppins rcp-text-3xl rcp-font-bold">
            {{ ':' }}
        </div>
        <div
            class="rcp-bg-neutral rcp-countdown-box rcp-text-neutral-content p-2 rcp-flex rcp-flex-col"
        >
            <span class="rcp-countdown rcp-timer rcp-font-poppins rcp-text-5xl">
                <span
                    style="--value: 59"
                    aria-live="polite"
                    aria-label="59"
                    >{{ countDownValue() | countDown: 'ss' }}</span
                >
            </span>
            {{ 'sec' }}
        </div>
    </div>
</app-form-dialog-wrapper>
